<!--begin::Body-->
<div class="lum-auth">
  <!--begin::Signin-->
  <div class="lum-auth-title">
    <h3 [translate]="'AUTH.FORGOT.TITLE'">Recover My Password</h3>
  </div>

  <form
    class="lum-auth-form"
    autocomplete="off"
    [formGroup]="forgotPasswordForm"
    (submit)="handleSubmit($event)"
  >
    <div class="form-group lum-auth-form-group">
      <input
        type="email"
        placeholder="Email address"
        formControlName="email"
        autocomplete="off"
        class="lum-input lum-input--primary lum-auth-input"
        [ngClass]="{
          'lum-auth-input--has-error':
            isControlHasError('email', 'required') ||
            isControlHasError('email', 'email') ||
            isControlHasError('email', 'maxLength'),
        }"
      />
      <div class="lum-auth-input-error">
        <mat-error *ngIf="isControlHasError('email', 'required')">
          <strong
            [translate]="'FORM.VALIDATION.REQUIRED'"
            [translateParams]="{ name: 'FORM.INPUT.EMAIL' | translate }"
          >
            Email address required</strong
          >
        </mat-error>
        <mat-error *ngIf="isControlHasError('email', 'email')">
          <strong
            [translate]="'FORM.VALIDATION.INVALID'"
            [translateParams]="{ name: 'FORM.INPUT.EMAIL' | translate }"
          >
            Invalid email format.</strong
          >
        </mat-error>
      </div>
    </div>
    <!--begin::Action-->
    <div class="lum-auth-actions">
      <button
        type="submit"
        id="kt_login_signin_submit"
        class="lum-button lum-button--primary"
        [ngClass]="{
          'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading,
        }"
        [translate]="'AUTH.FORGOT.BUTTON'"
        >Recover My Password</button
      >
      <a
        routerLink="/auth/login"
        id="kt_login_signup_cancel"
        class="lum-button lum-button--link"
        [translate]="'AUTH.GENERAL.BACK_BUTTON'"
        >Back to Login</a
      >
    </div>
    <!--end::Action-->
  </form>
</div>
